import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that displays a variant-metafield-driven badge.
 * Listens for variant update events and swaps its content from the
 * re-rendered section HTML so the badge reflects the newly selected variant.
 *
 * @extends {Component}
 */
class ProductBadge extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  /**
   * @param {import('./events').VariantUpdateEvent} event
   */
  updateBadge = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadge = event.detail.data.html.querySelector(
      `product-badge[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newBadge) return;

    this.innerHTML = newBadge.innerHTML;
  };
}

if (!customElements.get('product-badge')) {
  customElements.define('product-badge', ProductBadge);
}
